import Vue from 'vue';
import NewToast from './NewToast';

const ToastConstructor = Vue.extend(NewToast);

let instance;
let timer;

const createElement = () => {
  return new ToastConstructor({
    el: document.createElement('div'),
  });
};

const Toast = (options) => {

  // 创建元素
  if (!instance) {
    instance = createElement();
  }

  // 循环设置props
  typeof options === 'string' && (options = {
    text: options
  });
  for (const key in options) {
    if (options.hasOwnProperty(key)) {
      let value = options[key];
      if (key === 'text' && typeof value !== 'string') {
        value = 'Toast：text必须是string类型';
      }
      instance[key] = options[key];
    }
  }

  // 添加到页面
  document.body.appendChild(instance.$el);

  // 设置data属性
  Vue.nextTick(() => {
    instance.show = true;
    if (typeof options.time !== 'number') {
      options.time = 3000;
    }
    clearTimeout(timer);
    timer = setTimeout(() => {
      instance.show = false;
    }, options.time || 3000);
  });
};

export default Toast;

